import React from "react";
import {
  CancelButton,
  CircleText,
  ContainerButtons,
  ContentCircles,
  SaveButton,
} from "./Monogram.styled";
import PaletteIcon from "@mui/icons-material/Palette";
import { SketchPicker } from "react-color";
import PropTypes from "prop-types";

const Monogram = ({
  colorsavatar,
  colorSelected,
  setColorSelected,
  shortName,
  handleClickPalette,
  openPalette,
  handlePickerColorChange,
  handleSaveMonogram,
  setOpenModalProfile,
}) => {
  return (
    <>
      <ContentCircles>
        {Array.isArray(colorsavatar) && colorsavatar.map((c) => {
          return (
            <CircleText
              key={c.id}
              onClick={() => setColorSelected(c.color)}
              bgColor={`${c.color}`}
              colorSelected={`${colorSelected}`}
            >
              {shortName}
            </CircleText>
          );
        })}
        <PaletteIcon
          className="palette-icon"
          onClick={() => handleClickPalette(openPalette)}
        />
        {openPalette && (
          <div className="app-palette">
            <SketchPicker
              color={colorSelected}
              className="sketch-color"
              onChangeComplete={(color) => {
                handlePickerColorChange(color ? color : color.hex);
              }}
            />
          </div>
        )}
      </ContentCircles>
      <ContainerButtons>
        <CancelButton onClick={() => setOpenModalProfile(false)}>
          Cancel
        </CancelButton>
        <SaveButton onClick={() => handleSaveMonogram()}>Save</SaveButton>
      </ContainerButtons>
    </>
  );
};

export default Monogram;

Monogram.propTypes = {
  handleSaveMonogram: PropTypes.func,
  handleClickPalette: PropTypes.func,
  colorSelected: PropTypes.string,
  setColorSelected: PropTypes.func,
  colorsavatar: PropTypes.array,
  shortName: PropTypes.string,
  openPalette: PropTypes.bool,
  handlePickerColorChange: PropTypes.func,
  setOpenModalProfile: PropTypes.func,
};